import { useMemo } from 'react';

import { BarChartCard, BarChartSubtitle } from 'componets/ui';

import { useAppSelector, useTranslate } from 'hooks';

import { getDepositWithdrawal } from 'features/statement/actions';

const BARS = [
	{ dataKey: 'deposit', name: 'depositChartText', fill: '#65ABFF' },
	{ dataKey: 'withdrawal', name: 'withdrawChartText', fill: '#FB827A' },
];

export const DepositWithdrawal = () => {
	const depositWithdrawal = useAppSelector((state) => state.statement.depositWithdrawal);

	const { depositChartText, withdrawChartText } = useTranslate([
		'depositChartText',
		'withdrawChartText',
	]);

	const total = useMemo(
		() =>
			depositWithdrawal.items.reduce(
				(total, item) => total + Number(item.withdrawal) + Number(item.deposit),
				0,
			),
		[depositWithdrawal],
	);

	const data = useMemo(
		() =>
			depositWithdrawal.items.map((item) => {
				return { ...item, withdrawal: Number(item.withdrawal), deposit: Number(item.deposit) };
			}),
		[depositWithdrawal.items],
	);
	return (
		<BarChartCard
			minPointSize={2}
			total={total}
			subtitle={
				<BarChartSubtitle first={depositWithdrawal.deposit} second={depositWithdrawal.withdrawal} />
			}
			data={data}
			getData={getDepositWithdrawal}
			title={`${depositChartText} / ${withdrawChartText}`}
			bars={BARS}
			isProfit={false}
			isInvestment={false}
		/>
	);
};
